import { ModuleRegistry } from 'ag-grid-community';
import { AllEnterpriseModule, LicenseManager } from 'ag-grid-enterprise';
import { createTheme } from '@mui/material';

// Register all AG Grid Enterprise modules globally
ModuleRegistry.registerModules([AllEnterpriseModule]);

// AG Grid Enterprise License (AG-101984, 1823 Partners, expires 11 June 2027)
LicenseManager.setLicenseKey(
  'Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-101984}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Prosperity_Asset_Management}_is_granted_a_{Multiple_Applications}_Developer_License_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Charts_and_AG_Grid}_Enterprise___This_key_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{11_June_2027}____[v3]_[0102]_MTgxMjY2ODQwMDAwMA==7500cb239a601ce18a476813d3a55444'
);

// Default MUI theme for 1823 apps
export const defaultTheme = createTheme({
  palette: { mode: 'light' },
});
